import axios from "axios";
import { RESTAURANT_PAYMENTS_URL, OVERDUE_PAYMENTS_URL } from "../../config";

import {
  FETCH_RESTAURANT_PAYMENTS,
  FETCH_OVERDUE_PAYMENTS,
  CLEAR_RESTAURANT_PAYMENTS
} from "./actionTypes";

/**
 * Pobieranie listy płatności dla podanej restauracji z serwera
 * 
 * @param {int} restaurantId identyfikator restauracji
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchRestaurantPayments = (restaurantId, callback) => {
  return dispatch => {
    return axios
      .get(RESTAURANT_PAYMENTS_URL(restaurantId))
      .then(response => {
        dispatch(fetchRestaurantPaymentsSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Pobieranie listy płatności restauracji zaległych(niezapłaconych w terminie) z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchOverduePayments = (callback) => {
  return dispatch => {
    return axios
      .get(OVERDUE_PAYMENTS_URL)
      .then(response => {
        dispatch(fetchOverduePaymentsSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Czyszczenie listy płatności dla wybranej restauracji
 * 
 */
export const clearRestaurantPayments = () => {
  return dispatch => {
    dispatch(clearRestaurantPaymentsSuccess());
  };
};

/**
 * Akcja pomyślnego pobrania listy płatności restauracji 
 * 
 * @param {Array} data obiekt pobranej listy płatności restauracji
 */
export const fetchRestaurantPaymentsSuccess = data => {
  return {
    type: FETCH_RESTAURANT_PAYMENTS,
    payload: data
  };
};

/**
 * Akcja pomyślnego czyszczenia listy płatności restauracji 
 * 
 */
export const clearRestaurantPaymentsSuccess = () => {
  return {
    type: CLEAR_RESTAURANT_PAYMENTS
  };
};

/**
 * Akcja pomyślnego pobrania listy płatności przedawnionych
 * 
 * @param {Array} data obiekt pobranej listy przedawnionych płatności
 */
export const fetchOverduePaymentsSuccess = data => {
  return {
    type: FETCH_OVERDUE_PAYMENTS,
    payload: data
  };
};